// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableglosary {
    width: 100%;
    margin-bottom: 1rem;
    color: #28282d;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Coral/Driveanalysis_Coral/GlossaryPage_Coral.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":[".tableglosary {\n    width: 100%;\n    margin-bottom: 1rem;\n    color: #28282d;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
